import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { take } from 'rxjs';
import { ContactService } from '../../services/contact.service';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { ContactMethodControlComponent } from '../contact-method-control/contact-method-control.component';
import { NgFor } from '@angular/common';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
  selector: 'app-create-contact',
  templateUrl: './create-contact.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ContactService],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    NgFor,
    ContactMethodControlComponent,
    MatIconButton,
    MatIcon,
    MatButton,
    MatDialogActions,
    MatDialogClose
  ]
})
export class CreateContactComponent {
  form = new FormGroup({
    first_name: new FormControl<string>('', [Validators.required]),
    last_name: new FormControl<string>('', [Validators.required]),
    notes: new FormControl<string>(''),
    contact_methods: new FormArray([])
  });

  constructor(
    private contactService: ContactService,
    private dialogRef: MatDialogRef<CreateContactComponent>,
    @Inject(MAT_DIALOG_DATA) public customerId: number
  ) {}

  addContactMethod() {
    (this.form.get('contact_methods') as FormArray).push(
      new FormControl<{ type: 'email' | 'phone'; value: string }>({
        type: 'email',
        value: ''
      })
    );

    this.form.updateValueAndValidity();
  }

  removeContactMethod(index: number) {
    (this.form.get('contact_methods') as FormArray).removeAt(index);
  }

  submit() {
    this.contactService
      .create({
        ...this.form.getRawValue(),
        customer_id: this.customerId
      })
      .pipe(take(1))
      .subscribe((contact) => {
        this.dialogRef.close(contact);
      });
  }
}
